import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from './contexts/auth-context';
import { Toaster } from './components/ui/toaster';

import HomePage from './pages/HomePage';
import LoginPage from './pages/LoginPage';
import SignupPage from './pages/SignupPage';
import ResetPasswordPage from './pages/ResetPasswordPage';
import DashboardPage from './pages/dashboard/DashboardPage';
import CoursesPage from './pages/dashboard/CoursesPage';
import CourseDetailPage from './pages/dashboard/CourseDetailPage';
import CourseLearnPage from './pages/dashboard/CourseLearnPage';
import CreateCoursePage from './pages/dashboard/CreateCoursePage';
import MyCoursesPage from './pages/dashboard/MyCoursesPage';
import EditCoursePage from './pages/dashboard/EditCoursePage';
import MyLearningPage from './pages/dashboard/MyLearningPage';
import LivePage from './pages/dashboard/LivePage';
import LiveRoomPage from './pages/dashboard/LiveRoomPage';
import CreateLivePage from './pages/dashboard/CreateLivePage';
import CalendarPage from './pages/dashboard/CalendarPage';
import ProfilePage from './pages/dashboard/ProfilePage';
import EarningsPage from './pages/dashboard/EarningsPage';
import UsersPage from './pages/dashboard/UsersPage';
import PaymentsPage from './pages/dashboard/PaymentsPage';
import CategoriesPage from './pages/dashboard/CategoriesPage';
import PrivacyPage from './pages/dashboard/PrivacyPage';
import PaymentSuccessPage from './pages/payment/PaymentSuccessPage';
import PaymentCancelPage from './pages/payment/PaymentCancelPage';
import SettingsOverviewPage from './pages/dashboard/settings/SettingsOverviewPage';
import PaymentSettingsPage from './pages/dashboard/settings/PaymentSettingsPage';
import TwilioSettingsPage from './pages/dashboard/settings/TwilioSettingsPage';
import EmailSettingsPage from './pages/dashboard/settings/EmailSettingsPage';
import WhatsAppSettingsPage from './pages/dashboard/settings/WhatsAppSettingsPage';
import StorageSettingsPage from './pages/dashboard/settings/StorageSettingsPage';
import AccountPage from './pages/dashboard/AccountPage';
import BecomeTeacherPage from './pages/dashboard/BecomeTeacherPage';
import TeacherRequestsPage from './pages/dashboard/TeacherRequestsPage';

function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
}

function App() {
  return (
    <>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/signup" element={<SignupPage />} />
        <Route path="/reset-password" element={<ResetPasswordPage />} />

        <Route path="/dashboard" element={<ProtectedRoute><DashboardPage /></ProtectedRoute>} />
        <Route path="/dashboard/courses" element={<ProtectedRoute><CoursesPage /></ProtectedRoute>} />
        <Route path="/dashboard/courses/:id" element={<ProtectedRoute><CourseDetailPage /></ProtectedRoute>} />
        <Route path="/dashboard/courses/:id/learn" element={<ProtectedRoute><CourseLearnPage /></ProtectedRoute>} />
        <Route path="/dashboard/create-course" element={<ProtectedRoute><CreateCoursePage /></ProtectedRoute>} />
        <Route path="/dashboard/my-courses" element={<ProtectedRoute><MyCoursesPage /></ProtectedRoute>} />
        <Route path="/dashboard/my-courses/:id/edit" element={<ProtectedRoute><EditCoursePage /></ProtectedRoute>} />
        <Route path="/dashboard/my-learning" element={<ProtectedRoute><MyLearningPage /></ProtectedRoute>} />
        <Route path="/dashboard/live" element={<ProtectedRoute><LivePage /></ProtectedRoute>} />
        <Route path="/dashboard/live/:id" element={<ProtectedRoute><LiveRoomPage /></ProtectedRoute>} />
        <Route path="/dashboard/live/create" element={<ProtectedRoute><CreateLivePage /></ProtectedRoute>} />
        <Route path="/dashboard/calendar" element={<ProtectedRoute><CalendarPage /></ProtectedRoute>} />
        <Route path="/dashboard/profile" element={<ProtectedRoute><ProfilePage /></ProtectedRoute>} />
        <Route path="/dashboard/account" element={<ProtectedRoute><AccountPage /></ProtectedRoute>} />
        <Route path="/dashboard/settings" element={<ProtectedRoute><SettingsOverviewPage /></ProtectedRoute>} />
        <Route path="/dashboard/settings/payments" element={<ProtectedRoute><PaymentSettingsPage /></ProtectedRoute>} />
        <Route path="/dashboard/settings/twilio" element={<ProtectedRoute><TwilioSettingsPage /></ProtectedRoute>} />
        <Route path="/dashboard/settings/email" element={<ProtectedRoute><EmailSettingsPage /></ProtectedRoute>} />
        <Route path="/dashboard/settings/whatsapp" element={<ProtectedRoute><WhatsAppSettingsPage /></ProtectedRoute>} />
        <Route path="/dashboard/settings/storage" element={<ProtectedRoute><StorageSettingsPage /></ProtectedRoute>} />
        <Route path="/dashboard/earnings" element={<ProtectedRoute><EarningsPage /></ProtectedRoute>} />
        <Route path="/dashboard/users" element={<ProtectedRoute><UsersPage /></ProtectedRoute>} />
        <Route path="/dashboard/payments" element={<ProtectedRoute><PaymentsPage /></ProtectedRoute>} />
        <Route path="/dashboard/categories" element={<ProtectedRoute><CategoriesPage /></ProtectedRoute>} />
        <Route path="/dashboard/privacy" element={<ProtectedRoute><PrivacyPage /></ProtectedRoute>} />
        <Route path="/dashboard/become-teacher" element={<ProtectedRoute><BecomeTeacherPage /></ProtectedRoute>} />
        <Route path="/dashboard/teacher-requests" element={<ProtectedRoute><TeacherRequestsPage /></ProtectedRoute>} />

        <Route path="/payment/success" element={<ProtectedRoute><PaymentSuccessPage /></ProtectedRoute>} />
        <Route path="/payment/cancel" element={<ProtectedRoute><PaymentCancelPage /></ProtectedRoute>} />
      </Routes>
      <Toaster />
    </>
  );
}

export default App;
